import { ListaPedidos } from "@/pedidos/listaPedidos";
import { POST, server } from "@/state/server";
import { DateZod } from "@/state/types";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useRef } from "react";
import { z } from "zod";

export const Route = createFileRoute("/admin/pedidos/")({
  component: RouteComponent,
  validateSearch: z.union([
    z.object({}).strict(),
    z.object({
      fecha: DateZod,
      desde: z.boolean().optional(),
      incluir_pendientes: z.boolean().optional(),
    }),
    z.object({ numero: z.coerce.number() }),
    z.object({ email: z.string() }),
    z.object({ obs: z.string() }),
  ]),
});

function RouteComponent() {
  const search = Route.useSearch();
  const router = useRouter();

  const query =
    Object.keys(search).length > 0
      ? `buscar?${Object.entries(search)
          .map(([k, v]) => `${k}=${v}`)
          .join("&")}`
      : "dia";
  const url = `/admin/pedidos/${query}`;

  const nroPedido = useRef<HTMLInputElement>(null),
    fecha = useRef<HTMLInputElement>(null),
    pendientes = useRef<HTMLInputElement>(null),
    desde = useRef<HTMLInputElement>(null),
    email = useRef<HTMLInputElement>(null),
    obs = useRef<HTMLInputElement>(null);

  return (
    <>
      <div>
        <p>
          Buscar por pedido (4 dígitos)&nbsp;
          <input size={5} ref={nroPedido} />
          <button
            onClick={() =>
              nroPedido?.current != null &&
              router.navigate({
                to: "/admin/pedidos",
                search: { numero: Number(nroPedido.current.value) },
              })
            }
          >
            Buscar
          </button>
        </p>
        <p>
          Buscar por fecha&nbsp;
          <label>
            <input
              ref={desde}
              type="checkbox"
              defaultChecked={"desde" in search && search.desde}
            />{" "}
            Desde&nbsp;
          </label>
          <input
            ref={fecha}
            type="date"
            defaultValue={"fecha" in search ? search.fecha : ""}
          />
          <label>
            <input ref={pendientes} type="checkbox" /> Incluir pendientes
          </label>
          <button
            onClick={() =>
              fecha.current?.value &&
              router.navigate({
                to: "/admin/pedidos",
                search: {
                  fecha: fecha.current?.value,
                  ...(desde.current?.checked ? { desde: true } : {}),
                  ...(pendientes.current?.checked
                    ? { incluir_pendientes: true }
                    : {}),
                },
              })
            }
          >
            Buscar
          </button>
        </p>
        <p>
          Buscar por email&nbsp;
          <input
            ref={email}
            defaultValue={"email" in search ? search.email : ""}
          />
          <button
            onClick={() =>
              router.navigate({
                to: "/admin/pedidos",
                search: { email: email.current?.value ?? "" },
              })
            }
          >
            Buscar
          </button>
        </p>
        <p>
          Buscar por observaciones&nbsp;
          <input ref={obs} defaultValue={"obs" in search ? search.obs : ""} />
          <button
            onClick={() =>
              router.navigate({
                to: "/admin/pedidos",
                search: { obs: obs.current?.value ?? "" },
              })
            }
          >
            Buscar
          </button>
        </p>
        <p>
          <button
            onClick={() =>
              POST("/admin/pedido/nuevo").then((x) =>
                router.navigate({
                  to: "/admin/pedido",
                  search: { id: x.pedido.id },
                })
              )
            }
          >
            Venta directa
          </button>
        </p>
        <p>
          <a href={`${server}/admin/productos`}> configurar productos </a>
        </p>
      </div>
      <ListaPedidos url={url} showTotal={true} />
    </>
  );
}
